import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseIconButton, LinkIconButton } from './BaseIconButton';

const destructiveTertiaryIconButtonStyle = {
    color: colorSystem.neutral[7],
    '&:hover': {
        background: 'none',
        color: colorSystem.red[6],
    },
    '&:active': {
        background: 'none',
        color: colorSystem.red[7],
    },
    '&:disabled': {
        color: colorSystem.neutral[5],
    },
};

const DestructiveTertiaryIconButtonHost = styled(BaseIconButton)(destructiveTertiaryIconButtonStyle);
const DestructiveTertiaryIconButtonLinkHost = styled(LinkIconButton)(destructiveTertiaryIconButtonStyle);

export const DestructiveTertiaryIconButton = linkable(DestructiveTertiaryIconButtonHost, {
    linkHost: DestructiveTertiaryIconButtonLinkHost,
});
